export const breakdownByHourIdentifier = "breakdownByHourIdentifier"
